export default function Home(params) {
    return (
        <div>
            <h1>Home</h1>
        </div>
    );
};
